import React from 'react';
import ReactDOM from 'react-dom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import '../../styles/chapter2/slideshow_login.scss';
import '../../styles/transition-fadeDown.scss';
import Iconset from '../icons';


class SlideshowLogin extends React.Component{

	constructor(props){
		super(props);

		this.state = {
			isFilled : false,
			password : 'Enter Password',
			typedPassword : "",
			showLogin : true
		}
		this.pw = "kassel";
	}


	typePassword(event){
		//console.log(event.target.value);
		console.log('change');
		this.setState({
			isFilled : true,
			typedPassword : event.target.value,

		});
	}

	evaluatePassword(event){
		event.preventDefault();
		event.stopPropagation();

		if(this.state.typedPassword.toLowerCase() === this.pw){
			//console.log('true');

			this.props.success();
		}else{
			//console.log('wrong pw');
			this.inputField.className = "slideshow-login-inner wrong-pw";
			setTimeout(()=>{
				this.inputField.className = "slideshow-login-inner";
			},500);
			this.setState({
				typedPassword : ''
			});
		}
	}

	showLogin(){
		this.setState({
			showLogin : true
		})
	}

	render(){
		return (<div className={"slideshow-login timeline-visible-" + this.props.timelineVisible}>
				
				<ReactCSSTransitionGroup
					component= "div"
					className="slideshow-login-form"
			    transitionName="fade"
			    transitionAppear={true}
					transitionAppearTimeout={500}
			    transitionEnterTimeout={500}
			    transitionLeaveTimeout={300}>
						{this.state.showLogin && 
							<form ref={(inputField) => {this.inputField = inputField;}} className="slideshow-login-inner" onSubmit={(event)=>this.evaluatePassword(event)}>
								<div className="slideshow-login-password-icon">
									<a href="https://www.instagram.com/milkychance_official/" target="_blank">
										<Iconset.passwordIcon />
									</a>
								</div>
								<input type="text" placeholder={this.state.password} value={this.state.typedPassword} onChange={(event)=>this.typePassword(event)} onFocus={()=>this.props.hideTimeline()} onBlur={(event)=>this.props.showTimeline(event)}/>
								{this.state.isFilled &&
									<button className="slideshow-login-button"><Iconset.circleArrowToRightIcon /></button>
								}
							</form>
						}
				</ReactCSSTransitionGroup>
			</div>);
	}
}

export default SlideshowLogin;


// WEBPACK FOOTER //
// ./src/scripts/chapter2/slideshow_login.js